<div class="pilot-pay-categories-details">
	<form #form="ngForm">
		<div>
			<div fxFlex fxLayoutAlign="center center" fxLayoutGap="5px" fxLayout.xs="column" fxLayout.lg="row">
				<div *ngIf="!isArchived && !hasFutureChange">
					<span class="vertical-middle"> Changes goes into effect on: </span>
					<mat-form-field>
						<mat-select [(value)]="effectiveStartDate">
							<mat-option *ngFor="let t of payPeriods" [value]="t">
								{{ t.externalFormat }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<mat-error *ngIf="!isArchived && hasFutureChange" class="vertical-middle"
					>No edits can be made to this pay category while it has a future change or scheduled
					deletion.</mat-error
				>
				<div fxFlex></div>
				<div fxLayoutGap="5px" fxLayout.xs="row">
					<button
						id="PAY_CATEGORY_CHANGES_SAVE"
						class="form-button"
						*ngIf="payCategory.payCategoryId && isNeedDiscard && !isArchived && !hasFutureChange"
						color="blue"
						mat-raised-button
						(click)="updatePayCategory(payCategoryId.toString())"
					>
						Save Changes
					</button>
					<button
						id="NEW_PAY_CATEGORY_SAVE"
						class="form-button"
						*ngIf="!payCategory.payCategoryId && isNeedDiscard"
						color="blue"
						mat-raised-button
						(click)="createPayCategory()"
					>
						Save New
					</button>
					<button
						id="BACK_TO_PAY_CATEGORY_LIST"
						*ngIf="!isNeedDiscard || hasFutureChange"
						class="form-button"
						type="button"
						color="grey"
						mat-raised-button
						(click)="navigate()"
					>
						Back to List
					</button>
					<button
						id="PAY_CATEGORY_CHANGES_CANCEL"
						*ngIf="isNeedDiscard && !hasFutureChange"
						class="form-button"
						type="button"
						color="grey"
						mat-raised-button
						(click)="openAlertDialog('discard')"
					>
						Cancel
					</button>
					<button
						id="PAY_CATEGORY_DELETE"
						class="form-button"
						type="button"
						*ngIf="payCategory.payCategoryId && !isArchived && !hasFutureChange"
						color="grey"
						mat-raised-button
						(click)="openAlertDialog('delete')"
					>
						Delete
					</button>
				</div>
			</div>
		</div>
		<div class="mt-1 mb-1">
			<div class="details-form" fxLayout="row" fxLayout.xs="column" fxLayout.sm="column">
				<div fxFlex.gt-sm="55%" fxFlex="100">
					<app-details-card
						[payCategory]="payCategory"
						[isArchived]="isArchived"
						(onChange)="isNeedChange($event)"
					></app-details-card>
				</div>
				<div fxFlex.gt-sm="45%" fxFlex="100">
					<app-settings-card
						[isArchived]="isArchived"
						[payCategory]="payCategory"
						(onChange)="isNeedChange($event)"
					></app-settings-card>
				</div>
			</div>
			<div class="details-form" fxLayout="row" fxLayoutWrap="wrap">
				<div fxFlex.gt-sm="100%" fxFlex="100%">
					<app-notes-card
						[isArchived]="isArchived"
						[payCategoryId]="payCategory.payCategoryId"
						[notes]="payCategory.notes"
						(onNotesChange)="onNotesChange($event)"
						(onNotesDelete)="onNotesDelete($event)"
					></app-notes-card>
				</div>
			</div>
			<div fxLayout="row">
				<div fxFlex.gt-sm="100%" fxFlex="100" *ngIf="payCategoryChanges && payCategoryChanges.length">
					<mat-card class="expander">
						<mat-card-title>
							<div id="PAY_CATEGORY_FUTURE_CHANGES_TITLE">Future Changes</div>
							<div fxFlex></div>
							<button
								id="PAY_CATEGORY_FUTURE_CHANGES_DELETE"
								type="button"
								mat-icon-button
								class="ml-1"
								(click)="deletePayCategoryFutureChanges()"
							>
								<mat-icon class="grey">delete</mat-icon>
							</button>
							<button
								id="PAY_CATEGORY_FUTURE_CHANGES_TOGGLE"
								type="button"
								mat-icon-button
								class="ml-1"
								(click)="futureChangesToggle = !futureChangesToggle"
							>
								<mat-icon *ngIf="!futureChangesToggle">keyboard_arrow_down</mat-icon>
								<mat-icon *ngIf="futureChangesToggle">keyboard_arrow_up</mat-icon>
							</button>
						</mat-card-title>
						<hr />
						<div [hidden]="!futureChangesToggle">
							<app-changes-display
								[history]="payCategoryChanges"
								idPrefix="PAY_CATEGORY_FUTURE_CHANGES"
							></app-changes-display>
						</div>
					</mat-card>
				</div>
			</div>
			<div fxLayout="row">
				<div fxFlex.gt-sm="100%" fxFlex="100" *ngIf="payCategoryHistory && payCategoryHistory.length">
					<mat-card class="expander">
						<mat-card-title>
							<div id="PAY_CATEGORY_HISTORY_TITLE">History</div>
							<div fxFlex></div>
							<button
								id="PAY_CATEGORY_HISTORY_TOGGLE"
								type="button"
								mat-icon-button
								class="ml-1"
								(click)="historyToggle = !historyToggle"
							>
								<mat-icon *ngIf="!historyToggle">keyboard_arrow_down</mat-icon>
								<mat-icon *ngIf="historyToggle">keyboard_arrow_up</mat-icon>
							</button>
						</mat-card-title>
						<hr />
						<div [hidden]="!historyToggle">
							<app-changes-display
								[history]="payCategoryHistory"
								idPrefix="PAY_CATEGORY_HISTORY"
							></app-changes-display>
						</div>
					</mat-card>
				</div>
			</div>
		</div>
	</form>
</div>
